// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=ff95bbf5-3c6c-4766-95b2-41a079ab805b";
};